<template>
  <div>
    <div class="Kanit">
      <div class="text-center mt-8">
        <img height="100px" src="@/assets/logo.png" />
      </div>
      <ValidationObserver ref="observer">
        <div class="px-5">
          <div class="mt-4 mb-3 primary--text">
            กรุณากรอกเลขบัตรประจำตัวประชาชน
          </div>
          <ValidationProvider
            name="เลขบัตรประชาชน"
            rules="thai_idcard"
            v-slot="{ errors }"
          >
            <custom-input
              v-model="input.identityNumber"
              :placeholder="'บัตรประจำตัวประชาชน'"
              outlined
              :error-messages="errors"
              numberOnly
              :maxlength="13"
            >
            </custom-input>
          </ValidationProvider>
        </div>
        <div class="text-center">
          <v-btn @click="next" :loading="saveloading" large color="primary"
            >ยืนยัน</v-btn
          >
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import CustomInput from "../../components/CustomInput.vue";
import axios from "axios";
export default {
  components: { CustomInput },
  data() {
    return {
      input: {
        identityNumber: "",
      },
      saveloading: false,
    };
  },
  computed: {
    pageId() {
      return this.query.pageid;
    },
  },
  created() {
    this.$store.state.headertext = "";
  },
  methods: {
    async next() {
      if (await this.$refs.observer.validate()) {
        this.saveloading = true;
        axios
          .get(this.serverUrl + "yasale/member-by-identitynumber", {
            headers: { AUTHORIZATION: "Bearer xxxx xxxx" },
            params: {
              identityNumber: this.input.identityNumber,
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              let userData = response.data.data[0];
              // Call API to generate OTP

              let body = {
                pageId: this.pageId,
                userId: this.userid,
                phone: userData.username,
              };
              let otpResult = await axios.post(
                this.serverUrl + "yasale/otp/send",
                body,
                {
                  headers: {
                    AUTHORIZATION: "Bearer xxx xxx",
                  },
                }
              );

              if (otpResult.data && otpResult.data.responsecode == 200) {
                this.$store.state.ref = otpResult.data.data;
              } else {
                await this.$swal.fire({
                  type: "error",
                  text: "มีบางอย่างผิดพลาด",
                });
              }

              userData.phone = userData.username;
              userData.email = "";

              this.saveloading = false;
              this.$store.state.forgetPasswordData = userData;
              this.$emit("nextstep");
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
